import { FormattedMessage } from 'react-intl';
import type { To } from 'react-router';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconChevronLeft } from '@sorare/core/src/atoms/icons/system/iconChevronLeft.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSafePreviousNavigate } from '@sorare/core/src/hooks/useSafePreviousNavigate';
import { glossary } from '@sorare/core/src/lib/glossary';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';
import {
  laptopAndAbove,
  mediumDesktopAndAbove,
} from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

const wrapper = css`
  margin-bottom: var(--unit);

  @media ${laptopAndAbove} {
    padding: var(--unit);
    margin: 0;
  }
`;

const buttonLabel = css`
  display: none;

  @media ${mediumDesktopAndAbove} {
    display: block;
  }
`;

type Props = {
  safePath?: To;
};

export const BackButton = ({ safePath }: Props) => {
  const { sport } = useSportContext();
  const navigateSafePrevious = useSafePreviousNavigate(
    safePath || generateSportPath('', { sport })
  );

  return (
    <Horizontal className={wrapper}>
      <Button
        color="tertiary"
        size="medium"
        startIcon={<FontAwesomeIcon icon={iconChevronLeft} />}
        onClick={navigateSafePrevious}
      >
        <p className={buttonLabel}>
          <FormattedMessage {...glossary.back} />
        </p>
      </Button>
    </Horizontal>
  );
};
